// libraries
import React from "react";
// styles
import "../styles/Header.css";

export default function Header() {
  return (
    <header className="header__component">
      <h1>Virtual Lollipop</h1>
      <p>
        because we all know someone <br /> who deserves some sugar
      </p>
    </header>
  );
}
